export const getMissionUrl = (baseUrl: string) => {
  const missionUrl = `${baseUrl}/mission`
  return {
    CREATE_AND_LIST: missionUrl,
    ONE_MISSION: (mission_id: string) => `${missionUrl}/${mission_id}`, // update delete 포함
    UPDATE_STORE_STATUS: (mission_id: string) => `${missionUrl}/${mission_id}/stored`,
    CALENDAR: (mission_id: string) => `${missionUrl}/${mission_id}/calendar`
  }
}
